document.addEventListener("DOMContentLoaded", function () {
  const generateBtn = document.getElementById("generateBtn");
  const downloadBtn = document.getElementById("downloadBtn");

  if (generateBtn && downloadBtn) {
    generateBtn.addEventListener("click", drawSheet);
    downloadBtn.addEventListener("click", exportPDF);
  }

  function drawSheet() {
    const canvas = document.getElementById("sheetCanvas");
    const ctx = canvas.getContext("2d");
    const mmToPx = 3.78;
    const dpiScale = 2.5;

    canvas.style.display = "block";

    let paperWidthMM = 210;
    let paperHeightMM = 297;
    const selectedSize = document.getElementById("paperSize").value;
    if (selectedSize === "A5") {
      paperWidthMM = 148;
      paperHeightMM = 210;
    } else if (selectedSize === "A6") {
      paperWidthMM = 105;
      paperHeightMM = 148;
    } else if (selectedSize === "custom") {
      paperWidthMM = parseFloat(document.getElementById("customWidth").value);
      paperHeightMM = parseFloat(document.getElementById("customHeight").value);
    }

    const orientation = document.getElementById("orientation").value;
    if (orientation === "landscape") {
      [paperWidthMM, paperHeightMM] = [paperHeightMM, paperWidthMM];
    }

    const canvasWidth = paperWidthMM * mmToPx;
    const canvasHeight = paperHeightMM * mmToPx;

    canvas.width = canvasWidth * dpiScale;
    canvas.height = canvasHeight * dpiScale;
    canvas.style.width = canvasWidth + "px";
    canvas.style.height = canvasHeight + "px";

    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.scale(dpiScale, dpiScale);

    const marginMM = 10;
    const marginPx = marginMM * mmToPx;
    const spacingMM = parseFloat(document.getElementById("xHeightMM").value) || 5;
    const slantAngle = parseFloat(document.getElementById("slantAngle").value) || 55;
    const radians = (90 - slantAngle) * Math.PI / 180;
    const spacingPx = spacingMM * mmToPx;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.strokeStyle = "#888";
    ctx.lineWidth = 0.3;

    ctx.beginPath();
    ctx.rect(marginPx, marginPx, canvasWidth - 2 * marginPx, canvasHeight - 2 * marginPx);
    ctx.stroke();

    ctx.save();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.font = `${11 * dpiScale}px Century Gothic`;
    ctx.fillStyle = "#000";
    ctx.textAlign = "center";
    ctx.textBaseline = "top";
    ctx.fillText("Handwrite House Guidesheet", canvas.width / 2, marginPx * dpiScale / 2);
    ctx.textBaseline = "bottom";
    ctx.fillText("Handwrite House© All Right Reserved", canvas.width / 2, canvas.height - marginPx * dpiScale / 2);
    ctx.restore();

    for (let y = marginPx; y <= canvasHeight - marginPx; y += spacingPx) {
      ctx.beginPath();
      ctx.moveTo(marginPx, y);
      ctx.lineTo(canvasWidth - marginPx, y);
      ctx.stroke();
    }

    const fullHeight = canvasHeight - 2 * marginPx;
    const dx = -fullHeight * Math.tan(radians);
    const slantSpacingMM = 20;
    const slantSpacingPx = slantSpacingMM * mmToPx;
    const horizontalSpacing = slantSpacingPx;

    const overshoot = canvasWidth + Math.abs(dx);
    const startX = marginPx - overshoot;
    const endX = canvasWidth - marginPx + overshoot;

    for (let x = startX; x <= endX; x += horizontalSpacing) {
      const x1 = x;
      const y1 = marginPx;
      const x2 = x + dx;
      const y2 = canvasHeight - marginPx;

      const clipped = clipToBox(x1, y1, x2, y2, marginPx, marginPx, canvasWidth - marginPx, canvasHeight - marginPx);
      if (clipped) {
        ctx.beginPath();
        ctx.moveTo(clipped.x1, clipped.y1);
        ctx.lineTo(clipped.x2, clipped.y2);
        ctx.stroke();
      }
    }
  }

  function clipToBox(x1, y1, x2, y2, xmin, ymin, xmax, ymax) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    let t0 = 0, t1 = 1;

    const clip = (p, q) => {
      if (p === 0) return q >= 0;
      const r = q / p;
      if (p < 0) {
        if (r > t1) return false;
        if (r > t0) t0 = r;
      } else {
        if (r < t0) return false;
        if (r < t1) t1 = r;
      }
      return true;
    };

    if (
      clip(-dx, x1 - xmin) &&
      clip(dx, xmax - x1) &&
      clip(-dy, y1 - ymin) &&
      clip(dy, ymax - y1)
    ) {
      return {
        x1: x1 + t0 * dx,
        y1: y1 + t0 * dy,
        x2: x1 + t1 * dx,
        y2: y1 + t1 * dy
      };
    }

    return null;
  }

  function exportPDF() {
    const mmToPt = 2.83465;
    const mmToPx = 3.78;

    const paperSize = document.getElementById("paperSize").value;
    let widthMM = 210;
    let heightMM = 297;

    if (paperSize === "A5") {
      widthMM = 148;
      heightMM = 210;
    } else if (paperSize === "A6") {
      widthMM = 105;
      heightMM = 148;
    } else if (paperSize === "custom") {
      widthMM = parseFloat(document.getElementById("customWidth").value);
      heightMM = parseFloat(document.getElementById("customHeight").value);
    }

    const orientation = document.getElementById("orientation").value;
    const isLandscape = orientation === "landscape";

    const pdfWidthPt = isLandscape ? heightMM * mmToPt : widthMM * mmToPt;
    const pdfHeightPt = isLandscape ? widthMM * mmToPt : heightMM * mmToPt;

    const canvasWidthPx = isLandscape ? heightMM * mmToPx : widthMM * mmToPx;
    const canvasHeightPx = isLandscape ? widthMM * mmToPx : heightMM * mmToPx;

    html2canvas(document.getElementById("sheetCanvas"), {
      scale: 3,
      width: canvasWidthPx,
      height: canvasHeightPx,
      useCORS: true
    }).then(canvas => {
      const imgData = canvas.toDataURL("image/jpeg", 0.95);
      const { jsPDF } = window.jspdf;

      const pdf = new jsPDF({
        orientation: isLandscape ? "landscape" : "portrait",
        unit: "pt",
        format: [pdfWidthPt, pdfHeightPt]
      });

      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidthPt, pdfHeightPt);
      pdf.save("Handwrite House Guidesheet.pdf");
    }).catch(err => {
      console.error("html2canvas error:", err);
    });
  }
});
